import { POLICY_COMPLIANCE_QUERY_KEYS } from '_services/graphql/policy-compliance.queries'
import { PENDING_ITEMS_HANDOFF_QUERY_KEYS } from '_services/graphql/pending-items-handoff.queries'
import { EQUIPMENT_COMPLIANCE_QUERY_KEYS } from '_services/graphql/equipment-compliance-report.queries'

export const READINESS_DEPENDENT_QUERY_KEYS = [
  POLICY_COMPLIANCE_QUERY_KEYS.clientPolicyCompliance,
  POLICY_COMPLIANCE_QUERY_KEYS.clientPolicyAgreements,
  POLICY_COMPLIANCE_QUERY_KEYS.clientPolicyRelations,
  PENDING_ITEMS_HANDOFF_QUERY_KEYS.equipmentReadiness,
  PENDING_ITEMS_HANDOFF_QUERY_KEYS.equipmentReadinessBatch,
  PENDING_ITEMS_HANDOFF_QUERY_KEYS.recipients,
  PENDING_ITEMS_HANDOFF_QUERY_KEYS.activeHandoffs,
  PENDING_ITEMS_HANDOFF_QUERY_KEYS.handoff,
  EQUIPMENT_COMPLIANCE_QUERY_KEYS.report,
  EQUIPMENT_COMPLIANCE_QUERY_KEYS.bulkSendPreview,
] as const

export const POLICY_SETTINGS_DEPENDENT_QUERY_KEYS = [
  POLICY_COMPLIANCE_QUERY_KEYS.sitePolicies,
  POLICY_COMPLIANCE_QUERY_KEYS.sitePolicyRevisions,
  ...READINESS_DEPENDENT_QUERY_KEYS,
] as const

export const JURISDICTION_RULE_DEPENDENT_QUERY_KEYS = [
  POLICY_COMPLIANCE_QUERY_KEYS.jurisdictionRules,
  ...READINESS_DEPENDENT_QUERY_KEYS,
] as const

export const POLICY_COMPLIANCE_SETTINGS_DEPENDENT_QUERY_KEYS = [
  POLICY_COMPLIANCE_QUERY_KEYS.policyComplianceSettings,
  ...READINESS_DEPENDENT_QUERY_KEYS,
] as const

export const CLIENT_POLICY_DEPENDENT_QUERY_KEYS = READINESS_DEPENDENT_QUERY_KEYS
